module.exports = __webpack_public_path__ + "static/media/flower12.743dde78.png";